import styled from "styled-components";

export default styled.h1`
    margin: 0;
    font-size: 21px;
    line-height: 28px;
    font-weight: 600;
    letter-spacing: 0.25px;
`;